import { useState } from "react";

const links = [
  { href: "#today", label: "今日吃瓜" },
  { href: "#follow", label: "持续跟进" },
  { href: "#channels", label: "题材频道" },
  { href: "#topics", label: "热门专题" },
  { href: "#faq", label: "围观问答" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-background-200/70 bg-background-50/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-water-flash-line text-lg" aria-hidden="true" />
          </span>
          <span className="font-label text-lg font-extrabold tracking-tight text-foreground-950">
            免费吃瓜
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#today"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            零元直接看
            <i className="ri-arrow-right-line ml-1" aria-hidden="true" />
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-xl border border-background-200 bg-background-50 text-foreground-800 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端菜单">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#today"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-bold text-background-50 hover:bg-primary-600"
            >
              零元直接看
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}